import React, {useCallback, useEffect, useState} from "react";
export function Facets({initalFacets, meta, handleFacetData}) {
  const [facetData, setFacetData] = useState();
  const [openAccordions, setOpenAccordions] = useState([]);

  useEffect(  () => {
    setFacetData(initalFacets);
  },[ initalFacets ]);

  const handleFacetClick = (facetName, id) => {
    facetData[facetName] = facetData[facetName] ?? [];
    let data = facetData[facetName];

    if (!data.includes(id)) {
      data = data.push(id);
      setFacetData({...facetData, ...data});
    }
    else {
      facetData[facetName] = facetData[facetName].filter(a => a !== id);
      setFacetData({...facetData});
    }

    handleFacetData(facetData);
  };

  const handleAccordion = (id) => {
    if (openAccordions.includes(id)) {
      setOpenAccordions(openAccordions.filter(a => a !== id));
    }
    else {
      setOpenAccordions([...openAccordions, id]);
    }
  };

  const getChecked = useCallback( () => {
    let checked = [];
    for (let facet in facetData) {
      for (let item in facetData[facet]) {
        meta.facets.forEach((f) => {
          if (f.name === facet) {
            f.options.forEach((o) => {
              if (o.value === facetData[facet][item]) {
                checked.push(
                  <button key={o.id} className="facet__filter--active-list-item" aria-label="active filter list" onClick={() => handleFacetClick(f.name, o.value)}>
                    {o.label}
                    <svg width="15" height="14" viewBox="0 0 15 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path
                        d="M12.885 0L7.5 5.026L2.115 0L0 1.974L5.385 7L0 12.026L2.115 14L7.5 8.974L12.885 14L15 12.026L9.615 7L15 1.974L12.885 0Z"
                        fill="#000"></path>
                    </svg>
                  </button>
                );
              }
            });
          }
        });
      }
    }
    return (checked);
  }, [ facetData, meta ]);

  const getFacets = useCallback(() => {
    let renderedFacets = [];
    for (let i in meta.facets) {
      let facet = meta.facets[i];
      let id = facet.name;
      renderedFacets.push(
        <div key={id} className="facet__filter__item wdg-mb--xs">
          <a
            onClick={() => handleAccordion(id)}
            className={`facet__filter--title wdg-pb--xs ${openAccordions.includes(id) ? 'facet__filter--active' : ''}`}
          >
            <h3 className="facet__title">{facet.title}</h3>
          </a>
          <ul className={`facet__filter--list wdg-mb--xs  ${openAccordions.includes(id) ? 'facet__filter--active' : ''}`}>
            {getOptions(facet.name, facet.options ?? [], initalFacets ? initalFacets[id] ?? [] : [])}
          </ul>
        </div>
      );
    }

    return renderedFacets;
  }, [ facetData, meta, openAccordions ]);

  const getOptions = useCallback((name, options, checkedOptions) => {
    let renderedOptions = [];
    for (let i in options) {
      let option = options[i];
      let checked = facetData[name] ? facetData[name].includes(option.value) : false;

      renderedOptions.push(
        <li key={option.value} className="facet__label">
          <label>
            <input checked={checked} type="checkbox" onChange={() => handleFacetClick(name, option.value)}
                   id={option.value} name={option.label}/>
            <span className="check"></span>
            <span className="label">{option.label}</span>
          </label>
        </li>
      );
    }

    return renderedOptions;
  }, [ facetData, meta ]);

  return (
    <div className="facet__filter wdg-mb--md">
      <div className="facet__filter__items">
        {getFacets()}
      </div>
      <div className="facet__filter--active-list">
        {getChecked()}
      </div>
    </div>
  );
}
